const CUSTOM_OBJECTS_SUPPORTED_FIELD_TYPES = [
  { type: 'TEXT', limit: 80 },
  { type: 'EMAIL' },
  { type: 'CHECKBOX', limit: 30 },
  { type: 'PARAGRAPH', limit: 10 },
  { type: 'NUMBER', limit: 30 },
  { type: 'DECIMAL', limit: 20 },
  { type: 'DATE', limit: 30 },
  { type: 'DROPDOWN', limit: 30 },
  { type: 'DEPENDENT_FIELD' },
  { type: 'RELATIONSHIP', limit: 5 },
  { type: 'MULTI_SELECT', limit: 20 },
];

export { CUSTOM_OBJECTS_SUPPORTED_FIELD_TYPES };

export const HOST_DEFAULT_FEATURE_FLAG_CONFIGS = {
  configs: {
    featureFlagConfigs: {
      translations: true,
      recordWidgets: true,
      entityIcon: true,
      recordId: false,
      useTypeBasedApi: false,
      useDropdownLookup: false,
    },
    supportedFieldTypes: CUSTOM_OBJECTS_SUPPORTED_FIELD_TYPES,
    interopFlags: {
      entities: false,
      collections: false,
    },
    uiControlsConfigs: {
      entityList: {
        table: {
          columns: {
            icon: { visible: true },
            name: { visible: true },
            description: { visible: true },
            associated_objects: { visible: true },
            created_time: { visible: true },
          },
        },
      },
    },
  },
};

export default {
  manageTranslation: true, // to be activated after API and message channel Integration
  exportRecordsEnabled: false,
};
